<template>
    <section class="section-six pt-20 pb-20 no-border">
      <div class="section-six--wrapper">
        <div
          class="row xs-margin-bottom-20 md-margin-bottom-20"
          style="width: 100%;margin-left: 5px;"
        >
        </div>
      </div>
      <div class="section-six__title usatoBox ">LE ALTERNATIVE</div>
      <div class="title">
        Annunci simili
      </div>
      <div class="text-two">
        Annunci di altre marche o modelli di veicoli con caratteristiche simili al tuo che potrebbero essere valutati dagli utenti in fase di
        selezione e acquisto.
      </div>
      <div class="listing">
        <a v-for="(item, index) in limitedUsato" :key="index" :href="item.url" target="_blank">
        <div class="car-container">
            <div class="img-container">
                <img :src="item.thumb" alt="Car image" width="300px" height="200px" class="object-fit-cover">
                <div class="photo-counter">
                    {{ countImages(item.gallery) }}
                </div>
            </div>
            <div class="car-details">
                <div class="car-title">
                    {{ item.brand }} {{ item.model }} {{ item.version }}
                </div>
                <div class="car-info">
                    <span class="text-uppercase">{{ item.id_field1 }} | {{ item.company }}</span> | Km {{ formatNumber(item.num_fieldc) }} | {{ item.num_fielda }}
                </div>
                <div class="car-location">
                    {{ item.zip }} {{ item.city }} ({{ item.id_prov }})
                </div>
                <div class="car-price">
                    € {{ formatNumber(item.price) }}
                </div>
        </div>
        </div>
    </a>
      </div>
      <div>
        <div class="text-center mt-30">
            <a href="#" target="_blank">
                <button class="button-primary">
                    <span>Annunci simili</span>
                </button>
            </a>
        </div>
      </div>
    </section>
</template>

<script>
  export default {
    name: "LivemarketDataAlternatives",
    props: {
        usato: {
            type: Array,
            required: true,
        },
    },
    computed: {
    limitedUsato() {
      return this.usato.slice(0, 10);
    }
  },
  methods: {
    countImages(galleryString) {
      return galleryString ? galleryString.split('|').length : 0;
    },
    formatNumber(value) {
      if (value === null || value === undefined) {
        return '';
      }
      const parts = value.toString().split('.');
      // Format the integer part with dots as thousands separators
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join('.');
    },
  }
  };
</script>

<style scoped>
.section-six {
  padding: 58px 0px 78px;
  border-top: 2px solid #d20a11;
  margin: 0px 100px;
  position: relative;
}
.section-six--wrapper {
  max-width: 830px;
  width: 100%;
  margin: auto;
  display: flex;
}
.section-six__title {
  color: #ffffff;
  background-color: #d20a11;
  width: 152px;
  height: 33px;
  position: absolute;
  top: 0;
  left: 40.5%;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  line-height: 56px;
  letter-spacing: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title{
    color: #d20a11;
    font-size: 21px;
    line-height: 28px;
    font-weight: bold;
    margin: 30px 0 0 30px;
}
.text-two  {
    font-size: 0.875rem;
    line-height: 18px;
    margin: 5px 30px;
}
.listing {
    display: flex;
    flex-direction: column;
    align-items: start;
    padding-left: 30px;
}
a {
    text-decoration: none;
    color: #404041;
}
.img-container {
    position: relative;
}
.object-fit-cover{
object-fit: cover;
}
.car-container{
    height: 200px;
    display: flex;
    justify-content: flex-start;
    align-items: start;
    gap: 15px;
    margin-top: 30px;
}
/* .img-badge{
    position: absolute;
    top: 10px;
    right: 0;
    background-color: white;
    width: 40px;
    height: 20px;
} */
.car-details{
    display: flex;
    flex-direction: column;
    gap: 15px;
}
.car-title {
    margin-top: 15px;
    line-height: 28px;
    font-weight: 600;
    font-size: 20px;
    color: #404041;
}
.car-price {
    font-weight: 600;
    color: #d20a11;
    font-size: 18px;
}
@media (max-width: 992px) {
    .section-six {
        padding: 58px 20px 85px;
        margin: 0px 40px;
    }
    .section-six--wrapper {
        flex-direction: column;
    }
}
@media (max-width: 768px) {
    .section-six {
        padding: 35px 0px 95px;
        margin: 0px 17px;
    }
    .section-six__title {
        left: 30.5%;
        bottom: 98px;
    }
    .car-container {
    height: auto;
    flex-direction: column;
}
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/LivemarketDataAlternatives.vue